import { SOFTWARE_LD } from "@marketing/components/blocks";
import { Channels } from "@marketing/home/Channels";
import { Closing } from "@marketing/home/Closing";
import { Faq, HOME_FAQ } from "@marketing/home/Faq";
import { Features } from "@marketing/home/Features";
import { Fits } from "@marketing/home/Fits";
import { Hero } from "@marketing/home/Hero";
import { Voice } from "@marketing/home/Voice";
import { config } from "@repo/config";
import { pageHead, siteOrigin, siteShareCard } from "@shared/lib/meta";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

const title = "AI Shopping Assistant for Supermarkets | Hephon Commerce";
const description =
	"AI shopping assistant for supermarkets in Saudi Arabia and the UAE. Shoppers ask in Arabic or English, in your app, on WhatsApp or by phone.";
const head = pageHead({
	title,
	description,
	path: "/",
	image: {
		url: `${siteOrigin}/og/home.png?v=2`,
		alt: siteShareCard.alt,
	},
});

/** Who publishes the site (the full Organization lives on hephon.ai), the product, and the FAQ. */
const structuredData = {
	"@context": "https://schema.org",
	"@graph": [
		{
			"@type": "WebSite",
			"@id": `${siteOrigin}/#website`,
			name: config.appName,
			url: `${siteOrigin}/`,
			description,
			inLanguage: "en",
			publisher: { "@id": "https://hephon.ai/#organization" },
		},
		{
			"@type": "Organization",
			"@id": "https://hephon.ai/#organization",
			name: "Hephon",
			url: "https://hephon.ai",
			email: "hello@hephon.ai",
			sameAs: [
				"https://www.linkedin.com/company/hephon",
				"https://www.instagram.com/hephon.ai",
			],
		},
		SOFTWARE_LD,
		{
			"@type": "FAQPage",
			"@id": `${siteOrigin}/#faq`,
			mainEntity: HOME_FAQ.map((item) => ({
				"@type": "Question",
				name: item.q,
				acceptedAnswer: { "@type": "Answer", text: item.a },
			})),
		},
	],
};

export const Route = createFileRoute("/_marketing/")({
	head: () => ({
		...head,
		meta: [
			...head.meta,
			{
				name: "robots",
				content: "index, follow, max-image-preview:large",
			},
		],
		scripts: [
			{
				type: "application/ld+json",
				children: JSON.stringify(structuredData),
			},
		],
	}),
	component: HomePage,
});

/** The product live, where it works, a call, everything it does, how it fits, questions, the ask. */
function HomePage() {
	return (
		<>
			<Hero />
			{/* One boundary per section below the hero: React hydrates each as its own task
			    (selective hydration), so no single long task holds a phone's main thread. They
			    load no data, and every section is in the server HTML. */}
			<Suspense>
				<Channels />
			</Suspense>
			<Suspense>
				<Voice />
			</Suspense>
			<Suspense>
				<Features />
			</Suspense>
			<Suspense>
				<Fits />
			</Suspense>
			<Suspense>
				<Faq />
			</Suspense>
			<Suspense>
				<Closing />
			</Suspense>
		</>
	);
}
